const data = {
	"width": 24,
	"height": 24,
	"body": "<g id=\"evaArrowRightFill0\"><g id=\"evaArrowRightFill1\"><path id=\"evaArrowRightFill2\" fill=\"currentColor\" d=\"M10.46 18a2.23 2.23 0 0 1-.91-.2a1.76 1.76 0 0 1-1.05-1.59V7.79A1.76 1.76 0 0 1 9.55 6.2a2.1 2.1 0 0 1 2.21.26l5.1 4.21a1.7 1.7 0 0 1 0 2.66l-5.1 4.21a2.06 2.06 0 0 1-1.3.46Z\"/></g></g>"
};
exports.__esModule = true;
exports.default = data;
